module.exports = __webpack_public_path__ + "static/media/16UNODC31.aea5c710.jpg";